import React from "react";
import { LegalDossierPanel } from "@/components/LegalPanels";
import { FileText, Scale, ExternalLink } from "lucide-react";
import { Link } from "react-router-dom";

export default function AdminLegal() {
  const docs = [
    { label: "Privacy Policy", path: "/privacy", icon: FileText },
    { label: "Cookie Policy", path: "/cookie", icon: FileText },
    { label: "Termini e Condizioni", path: "/termini", icon: Scale },
    { label: "Codice Etico", path: "/codice-etico", icon: Scale },
  ];

  return (
    <div className="space-y-6">
      <div>
        <h1 className="font-display text-2xl sm:text-3xl font-bold text-slate-900">Compliance & Legale</h1>
        <p className="mt-1 text-slate-600">
          Strumenti per la revisione legale e la conformità GDPR.
        </p>
      </div>

      <LegalDossierPanel />

      <div className="cxo-card p-6" data-testid="published-docs-panel">
        <h2 className="font-display text-xl font-semibold text-slate-900">Documenti pubblicati sul sito</h2>
        <p className="text-sm text-slate-600 mt-1">
          Bozze attualmente accessibili pubblicamente. Aggiornarle dopo la revisione legale modificando <code className="bg-slate-100 px-1.5 py-0.5 rounded text-xs">/app/frontend/src/pages/LegalPage.jsx</code>.
        </p>
        <div className="mt-4 grid grid-cols-1 sm:grid-cols-2 gap-3">
          {docs.map((d) => (
            <Link
              key={d.path}
              to={d.path}
              target="_blank"
              className="flex items-center justify-between p-3 rounded-lg border border-slate-200 hover:border-[#2D6BFF] hover:bg-[#EAF0FF]/30 transition"
              data-testid={`legal-doc-${d.path.replace("/", "")}`}
            >
              <div className="flex items-center gap-2.5">
                <d.icon size={18} className="text-[#2D6BFF]" />
                <span className="font-medium text-slate-900 text-sm">{d.label}</span>
              </div>
              <ExternalLink size={14} className="text-slate-400" />
            </Link>
          ))}
        </div>
      </div>

      <div className="cxo-card p-6" data-testid="gdpr-info-panel">
        <h2 className="font-display text-xl font-semibold text-slate-900">Endpoint GDPR attivi</h2>
        <p className="text-sm text-slate-600 mt-1">
          Il sistema CXOORA implementa i diritti GDPR (artt. 15-22) via endpoint API tracciabili.
        </p>
        <div className="mt-4 overflow-x-auto">
          <table className="w-full text-sm">
            <thead className="bg-slate-50 text-xs uppercase tracking-wider text-slate-500">
              <tr>
                <th className="p-3 text-left">Diritto</th>
                <th className="p-3 text-left">Articolo</th>
                <th className="p-3 text-left">Endpoint</th>
                <th className="p-3 text-left">Disponibile a</th>
              </tr>
            </thead>
            <tbody>
              <Row right="Accesso ai dati" art="Art. 15" endpoint="GET /api/gdpr/export" who="Tutti gli utenti" />
              <Row right="Portabilità" art="Art. 20" endpoint="GET /api/gdpr/export?fmt=json" who="Tutti gli utenti" />
              <Row right="Cancellazione (oblio)" art="Art. 17" endpoint="DELETE /api/gdpr/delete-account" who="Tutti gli utenti" />
              <Row right="Limitazione del trattamento" art="Art. 18" endpoint="PUT /api/gdpr/restrict" who="Tutti gli utenti" />
              <Row right="Storico consensi" art="Art. 7" endpoint="GET /api/gdpr/consents" who="Tutti gli utenti" />
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}

const Row = ({ right, art, endpoint, who }) => (
  <tr className="border-t border-slate-100 hover:bg-slate-50">
    <td className="p-3 font-medium text-slate-900">{right}</td>
    <td className="p-3">
      <span className="inline-flex items-center px-2 py-0.5 rounded-full bg-[#EAF0FF] text-[#2D6BFF] text-xs font-semibold">{art}</span>
    </td>
    <td className="p-3 font-mono text-xs text-slate-700">{endpoint}</td>
    <td className="p-3 text-slate-600 text-xs">{who}</td>
  </tr>
);
